import { useState } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoriesSection() {
  const [selectedCategory, setSelectedCategory] = useState('');

  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      setSelectedCategory(url);
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <section id="categories" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 text-center mb-4">
          Przeglądaj kategorie Kakobuy Spreadsheet
        </h2>
        <div className="flex justify-center mb-8">
          <div className="w-16 h-1 bg-accent-500 rounded-full"></div>
        </div>

        <div className="max-w-md mx-auto mb-12">
          <div className="relative">
            <select
              value={selectedCategory}
              onChange={handleDropdownChange}
              className="w-full appearance-none bg-background-100 border border-background-300/60 rounded-xl px-5 py-3.5 pr-12 text-sm text-foreground-800 cursor-pointer focus:outline-none focus:border-accent-400 focus:ring-2 focus:ring-accent-100 transition-all"
            >
              <option value="" disabled>
                Wybierz kategorię...
              </option>
              <option value="https://kaspreadsheet.com/category-911-Shoes.html">Shoes</option>
              <option value="https://kaspreadsheet.com/search-912/name/Shoes.html">Hoodies / Sweaters</option>
              <option value="https://kaspreadsheet.com/search-913/name/Shoes.html">T-Shirts</option>
              <option value="https://kaspreadsheet.com/search-914/name/Shoes.html">Jackets</option>
              <option value="https://kaspreadsheet.com/search-915/name/Shoes.html">Pants / Shorts</option>
              <option value="https://kaspreadsheet.com/search-916/name/Shoes.html">Headwear</option>
              <option value="https://kaspreadsheet.com/search-917/name/Shoes.html">Sets</option>
              <option value="https://kaspreadsheet.com/search-918/name/Shoes.html">Underwear / Underpants</option>
              <option value="https://kaspreadsheet.com/search-919/name/Shoes.html">Jersey</option>
              <option value="https://kaspreadsheet.com/search-920/name/Shoes.html">Accessories</option>
              <option value="https://kaspreadsheet.com/search-921/name/Shoes.html">Bags</option>
              <option value="https://kaspreadsheet.com/search-922/name/Shoes.html">Belts</option>
              <option value="https://kaspreadsheet.com/search-923/name/Shoes.html">Perfumes</option>
              <option value="https://kaspreadsheet.com/search-924/name/Shoes.html">Other Stuff</option>
            </select>
            <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-foreground-500">
              <i className="ri-arrow-down-s-line text-lg"></i>
            </div>
          </div>
          <p className="text-xs text-foreground-500 text-center mt-3">
            Wybierz kategorię, aby przejść do pełnej listy produktów na kaspreadsheet.com
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-accent-300/60 transition-all cursor-pointer"
            >
              <div className="aspect-[4/3] w-full overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={`Kakobuy ${cat.name} Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={`Kakobuy ${cat.name} Spreadsheet`}
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              <div className="p-3 md:p-4 flex items-center gap-2.5">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                  <i className={`${cat.icon} text-sm`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-800 leading-tight group-hover:text-accent-600 transition-colors">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-accent-500 text-background-50 rounded-full text-base font-semibold hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
          >
            Zobacz wszystkie produkty
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}